/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Delete_TitleInputs */

const en_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Preset`)
};

const fr_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le preset`)
};

const de_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung löschen`)
};

const it_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina preimpostazione`)
};

const ru_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить предустановку`)
};

const es_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar ajuste preestablecido`)
};

const zh_cn2_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除预设`)
};

const ja_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを削除`)
};

const hi_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट हटाएं`)
};

const pt_pt2_preset_manager_delete_title = /** @type {(inputs: Preset_Manager_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir predefinição`)
};

/**
* | output |
* | --- |
* | "Delete Preset" |
*
* @param {Preset_Manager_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_delete_title = /** @type {((inputs?: Preset_Manager_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_delete_title(inputs)
	if (locale === "de") return de_preset_manager_delete_title(inputs)
	if (locale === "it") return it_preset_manager_delete_title(inputs)
	if (locale === "ru") return ru_preset_manager_delete_title(inputs)
	if (locale === "es") return es_preset_manager_delete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_delete_title(inputs)
	if (locale === "ja") return ja_preset_manager_delete_title(inputs)
	if (locale === "hi") return hi_preset_manager_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_delete_title(inputs)
	return en_preset_manager_delete_title(inputs)
});